type ChevronLeftProps = {
  className?: string;
};

const ChevronLeft = ({ className }: ChevronLeftProps) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/ChevronLeft/24dp">
      <path
        id="ChevronLeftVector"
        d="M10.8 12L14.7 15.9C14.8834 16.0833 14.975 16.3167 14.975 16.6C14.975 16.8833 14.8834 17.1167 14.7 17.3C14.5167 17.4833 14.2834 17.575 14 17.575C13.7167 17.575 13.4834 17.4833 13.3 17.3L8.70005 12.7C8.60005 12.6 8.52922 12.4917 8.48755 12.375C8.44588 12.2583 8.42505 12.1333 8.42505 12C8.42505 11.8667 8.44588 11.7417 8.48755 11.625C8.52922 11.5083 8.60005 11.4 8.70005 11.3L13.3 6.69999C13.4834 6.51665 13.7167 6.42499 14 6.42499C14.2834 6.42499 14.5167 6.51665 14.7 6.69999C14.8834 6.88332 14.975 7.11665 14.975 7.39999C14.975 7.68332 14.8834 7.91665 14.7 8.09999L10.8 12Z"
        fill="#212121"
      />
    </g>
  </svg>
);

export default ChevronLeft;
